/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Pagination, PaginationItem, PaginationLink, Label, Card, Form, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input } from 'reactstrap';
import Alert from 'react-s-alert';
// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import PhoneInput from 'react-phone-input-2';


const AddCounselorProfileIndividual = (props) => {
    // variables
    let timeout = 0;

    //stats
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState({ isVisible: false, index: -1 });
    // const [confirmationModal, setConfirmationModal] = useState({ isVisible: false});
    // const [profiles,setProfiles] = useState(data);
    const [pagination, setPagination] = useState({ limit: 3, page: 1, searchVal: "" });

    // contexts
    const { theme } = useContext(ThemeContext);

    const [client, setClient] = useState({});
    const [isDataModified, setIsDataModified] = useState(false);

    const handleChange = e => {
        try {
            setClient({ ...client, [e.target.name]: e.target.value });
            setIsDataModified(true);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin AddCounsellorProfileIndividual handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handlePhoneChange = e => {
        try {
            setClient({ ...client, phone: e });
            setIsDataModified(true);

        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin AddCounsellorProfileIndividual handlePhoneChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {

        e.preventDefault();

        try {
            setIsLoading(true);
            AdminService.postScrapeProviderProfiles([client])
                .then(data => {
                    setClient({})
                    Alert.info(data.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                    props.history.push("/admin/dashboard/scrapedCounsellorProfiles")
                })
                .catch(error => {
                    Alert.error(error.message.msgBody, {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    setIsLoading(false);
                });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin AddCounsellorProfileIndividual handleSubmit', 'Error in try catch block', err.stack);
            setIsLoading(false);
        }

    }

    return (
        <>
            <div className='container-fluid'>
                <h3 className='my-4'>Add Counsellor Profile</h3>
                <hr />
                <div className='wrapper text-center'>
                    <div className="btn-group" py style={{ marginLeft: "auto", marginRight: "auto" }} role="group" aria-label="Basic example">
                        <Button type="button" className="btn border">Individual</Button>
                        <Button type="button" onClick={() => { props.history.push("/admin/dashboard/addCounsellorSpreadsheet") }} outline className="btn border">Spreadsheet</Button>
                    </div>
                </div> 
                <div className='px-3 py-5'>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="Name" style={theme.formBodyText}>Name</Label>
                            <Input type='text' name='name' id='name' style={theme.formInput} className="w-50" onChange={handleChange}
                                placeholder="Counsellor Name" defaultValue={''} value={client.name} required></Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="Address" style={theme.formBodyText}>Address</Label>
                            <Input type='text' name='address' id='Address' style={theme.formInput}
                                placeholder="Address" className="w-50" onChange={handleChange} defaultValue={''} value={client.address} required></Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="phone" style={theme.formBodyText} >Phone</Label><br />
                            <div className="d-flex">
                                <PhoneInput
                                    placeholder="+91 98765-43120"
                                    inputClass="form-control w-auto"
                                    inputStyle={theme.formInput}
                                    value={client.phone}
                                    isValid={(value) => {
                                        if (value.slice(0, 2) !== "91") {
                                            return false;
                                        }
                                        return true;
                                    }}
                                    inputProps={{
                                        name: 'phone',
                                        required: true,
                                    }}
                                    country="in"
                                    disableDropdown={true}
                                    onChange={handlePhoneChange} />
                            </div>

                        </FormGroup>

                        <FormGroup>
                            <Label for="Website" style={theme.formBodyText}>Website</Label>
                            <Input type='text' name='Website' id='Website' style={theme.formInput}
                                placeholder="https://www.example.com"
                                className="w-50" onChange={handleChange} defaultValue={''} value={client.website} required></Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="UniqueID" style={theme.formBodyText}>Unique ID</Label>
                            <Input type='text'
                                placeholder="John Deo" name='UniqueID' id='UniqueID' style={theme.formInput} className="w-50" onChange={handleChange} defaultValue={''} value={client.uniqueId} required></Input>
                        </FormGroup>
                        <Button className="btn" style={{ backgroundColor: "#ffd800" }} type="submit">
                            Add Profile
                        </Button>
                    </Form>
                </div>
            </div>
        </>
    )
}

export default AddCounselorProfileIndividual